import setTimer from './setTimer';

/**
 * @callback updateValue
 * @param {number} newValue - newValue of the timer (goes down by 1 every second).
 */
/**
 * @param {number} newTimeout - cooldown time in seconds
 * @param {number} oldSetTimerId - ID of setTimer that needs to be stopped.
 * @param {updateValue} updateValue
 * If you don't want to stop any previous timers, just pass `-1`.
 */
export default function(newTimeout, updateValue, oldSetTimerId) {
  clearInterval(oldSetTimerId);
  let newValue = newTimeout;
  updateValue(newValue)
  setTimer(newTimeout * 1000, 1000, () => updateValue(--newValue));
}
